import QuotationSummaryTable from "./quotationSummaryTable"

export default QuotationSummaryTable
